import React from "react";
import "./ContactSection.css";

function ContactSection() {
  return (
    <section className="contact-section">
  <div className="contact-image"></div>
  <div className="contact-form-wrapper">
    <p className="contact-subtitle">CONTACT US</p>
    <h2 className="contact-title">
      HAVE QUESTIONS?<br />GET IN TOUCH!
    </h2>

    <form
      className="contact-form"
      method="POST"
      action="https://api.web3forms.com/submit"
    >
      <input type="hidden" name="access_key" value="4735d34a-0c64-44ce-b0d4-23d739f417655" />

      <div className="form-row">
        <input type="text" name="firstName" placeholder="Name" required />
        <input type="text" name="lastName" placeholder="Last Name" required />
      </div>
      <div className="form-row">
        <input type="email" name="email" placeholder="Email" required />
        <input type="tel" name="phone" placeholder="Phone" required />
      </div>
      <textarea name="message" placeholder="Message" rows="5" required></textarea>

      <button type="submit" className="submit-button">
        <i className="fas fa-paper-plane"></i> GET IN TOUCH
      </button>
    </form>

    {/* Contact Info Below Form */}
    <div className="contact-extra-info">
      <div className="info-block">
        <h4>Contact</h4>
        <p><strong>Email:</strong> contact@jgdetailingllc.com</p>
        <p><strong>Office:</strong> (763) 710-9136</p>
        <p><strong>John:</strong> (952) 215-9310</p>
        <p><strong>Glenn:</strong> (612) 229-9151</p>
      </div>

      <div className="info-block">
        <h4>Hours</h4>
        <p>Mon – Fri: 8am – 4pm</p>
        <p>Saturday: By Appt Only</p>
        <p>Sunday: Closed</p>
      </div>

    </div>
  </div>
</section>
  );
}

export default ContactSection;